<!-- ================管理端-推荐书目====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{!bookId?'创建推荐书目':'编辑推荐书目'}}</div>
        </div>
        <div class="create-content-container">
            <el-form style="padding-bottom: 15px;"
                     ref="form"
                     :model="form" :rules="rules"
                     label-width="100px">
                <el-row>
                    <el-col :span="15">
                        <el-row>
                            <el-col :span="22">
                                <el-form-item label="书籍名称" prop="bookName">
                                    <el-input v-model="form.bookName" placeholder="请输入书籍名称"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="书籍作者" prop="bookAuthor">
                                    <el-input v-model="form.bookAuthor" placeholder="请输入书籍作者"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="出版时间" prop="publishTime">
                                    <el-date-picker format="YYYY-MM-DD"
                                                    style="width: 100%;" v-model="form.publishTime"
                                                    type="datetime" placeholder="出版时间"
                                                    value-format="x" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="学段" prop="periodKey">
                                    <el-select @change="changePeriod"  v-model="form.periodKey" placeholder="请选择">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="年级" prop="gradeKey">
                                    <el-select v-model="form.gradeKey" placeholder="请选择">
                                        <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="年级段" prop="bookGradeList">
                                    <el-select multiple  v-model="form.bookGradeList" placeholder="请选择">
                                        <el-option v-for="item in bookGradeList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="书籍主题" prop="bookItemList">
                                    <el-select multiple v-model="form.bookItemList" placeholder="请选择">
                                        <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                                   :value="item.itemId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="导读视频" prop="bookVideo">
                                    <el-input disabled v-model="form.bookVideo" placeholder="请上传导读视频">
                                        <template #append>
                                            <el-button style="background-color: #377f7f;color: #fff" @click="handleUploadBookVideo">上传视频</el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="1"></el-col>
                    <el-col :span="8">
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="书籍封面" prop="bookCover">
                                    <el-upload class="avatar-uploader"
                                               :action="serviceUrl+'/businessservice/book/uploadCover'" :show-file-list="false"
                                               :on-success="handleAvatarSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                        <img alt="" v-if="form.bookCover" :src="form.bookCover" class="avatar" style="position:absolute" />
                                        <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                            <Plus />
                                        </el-icon>
                                    </el-upload>
                                    <div style="color: #a9abad;width:100%;">推荐使用260*185尺寸的图片</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="18">
                        <el-form-item label="书籍简介" prop="bookIntroduction">
                            <el-input type="textarea" rows="5" v-model="form.bookIntroduction" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="18">
                        <el-form-item label="推荐理由" prop="bookReason">
                            <el-input type="textarea" rows="5" v-model="form.bookReason" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="18">
                        <el-form-item label="书籍资料" prop="">
                            <el-upload v-model:file-list="fileList" class="upload-demo"
                                       :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/book/uploadFile'"
                                       :on-change="handleFileChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                       :before-upload="beforeFileUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>
    </div>

    <el-dialog title="导读视频" v-model="bookVideoIsDisplay" width="30%">
        <el-upload ref="upload"
                   class="upload-demo"
                   :limit="1"
                   :on-exceed="handleExceed"
                   accept=".mp4,.avi,.flv" :http-request="handleUpload">
            <el-button type="primary">点击上传</el-button>
            <template #tip>
                <div class="el-upload__tip">
                    只允许上传.mp4,.avi,.flv,格式文件。
                </div>
            </template>
        </el-upload>
    </el-dialog>
</template>
<script>
import {ElLoading} from "element-plus";
import {ossClient,serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/dict";
import {listItem} from "@/api/admin/item";
import {createBook, infoBook, updateBook} from "@/api/admin/book"
import {getFileNameUUID, signatureUrl} from "@/utils/tools";

export default {
    components: {},
    name: "bookCreate",
    data() {
        return {
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            bookVideoIsDisplay: false,
            bookId:'',
            fileList:[],
            delFileList:[],
            periodList:[],
            gradeList:[],
            bookGradeList:[],
            itemList:[],
            queryItemParams:{
                itemType:1,
                museumKey:'1',
            },
            // 表单参数
            form: {
                bookId:'',
                bookName:'',
                bookCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/bookCover.png',
                bookVideo:'',
                bookItem:'',
                bookItemList:'',
                bookAuthor:'',
                bookIntroduction:'',
                publishTime:'',
                bookReason:'',
                bookGrade:'',
                bookGradeList:'',
                periodKey:'',
                gradeKey:'',
                fileUrls:'',
            },
            rules:{
                bookName: [{ required: true, message: "请输入标题", trigger: "blur" },],
                bookCover: [{ required: true, validator: this.checkCoverValidator  },],
                // bookVideo: [{ required: true, message: "请上传导读视频", trigger: "change" },],
                bookItem: [{ required: true, message: "请选择主题", trigger: "change" },],
                bookAuthor: [{ required: true, message: "请输入作者", trigger: "blur" },],
                periodKey: [{ required: true, message: "请选择学段", trigger: "change" },],
                bookGradeList: [{ required: true, validator: this.checkBookGrade  },],
                bookItemList: [{ required: true, validator: this.checkBookItem  },],
                publishTime:[{ required: true, message: "请选择出版时间", trigger: "blur" },],
                bookIntroduction:[{ required: true, message: "请输入书籍简介", trigger: "blur" },],

            },
            loadingPercentage:0,
        }
    },
    computed: {},
    watch: {},
    created() {
        this.handleQueryDict();
        this.handleQueryItem();
    },
    mounted() {
        if (this.$route.query.bookId) {
            this.bookId = this.$route.query.bookId
            this.queryBookInfo()
        }
    },
    methods: {
        backList(){
            this.$router.push({
                path: "/book",
            });
        },
        handleQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.bookGradeList = res.data.data;
            })
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        handleQueryItem(){
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleUploadBookVideo(){
            this.bookVideoIsDisplay = true;
        },
        submitForm(){
            const fileList = [];
            this.fileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.form.fileUrls = fileList.toString();
                    this.form.bookGrade = this.form.bookGradeList.toString();
                    this.form.bookItem = this.form.bookItemList.toString();
                    this.form.releaseTime = this.setHms(this.form.releaseTime);
                    if (!this.bookId) {
                        createBook(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }else {
                        this.form.bookId = this.bookId;
                        updateBook(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }
                }
            });
        },
        queryBookInfo(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
                infoBook({ bookId: this.bookId }).then(res => {
                    if (res.data.code === 1) {
                        this.form = res.data.data;
                        this.periodList.forEach(j => {
                            if (this.form.periodKey === j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                        this.form.fileList.forEach(e => {
                            this.fileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                    }else {
                        this.$message.error("操作失败")
                    }
                })
            });

        },
        /*=========数据校验=========*/
        checkCoverValidator(rule, value, callback) {
            if (this.form.bookCover !== '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        checkBookGrade(rule, value, callback) {
            if (this.form.bookGradeList.length === 0) {
                callback(new Error('请选择年级段'))
            } else {
                callback()
            }
        },
        checkBookItem(rule, value, callback) {
            if (this.form.bookItemList.length === 0) {
                callback(new Error('请选择主题'))
            } else {
                callback()
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.form.bookCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleExceed(){},
        handleUpload(option){
            const loading = ElLoading.service({ fullscreen: true })
            var obj = option.file.name
            const index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + this.getFileName(option.file.name)
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/read/${objName}`, option.file).then(res => {
                signatureUrl(`/ygjy/read/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                        this.form.bookVideo = result;
                        loading.close()
                        this.bookVideoIsDisplay = false;
                    } else {
                        loading.close()
                    }
                })
            })
        },
        async multipartUpload(ObjName, fileUrl) {
            try {
                let result = await ossClient.multipartUpload(`${ObjName}`, fileUrl, {// 获取分片上传进度、断点和返回值。
                    progress: (p, cpt, res) => {
                        console.log(p);
                        this.loadingPercentage = parseInt(p * 100);
                    },
                    timeout: 600000000,
                    // 设置并发上传的分片数量。
                    parallel: 5,
                    // 设置分片大小。默认值为1 MB，最小值为100 KB。
                    partSize: 1024 * 1024 * 50,
                })
                // ObjName为文件名字,
                return result
            } catch (e) {
                this.form.bookVideo = '';
                this.$message.error('上传失败')
            }
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));//.txt
        },
        handleRemove(file, uploadFiles) {
        },
        handleFileChange(file) {
        },
        beforeFileUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type === 'application/pdf' || rawFile.type === 'application/vnd.ms-powerpoint' || rawFile.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
    },
}
</script>
<style>
.avatar-uploader .avatar {
    height: 260px;
    width: 185px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 260px;
    width: 185px;
    text-align: center;
}
</style>
